import can from 'can';
import BaseWidget from 'scripts/base-widget';
import 'components/victory-club/subnavigation/vc-subnavigation';

export const VCSubnavigation = BaseWidget.extend({
    init: function() {
        this.view = can.stache('<vc-subnavigation />');
        this._super();
    },
});
